import Head from 'next/head';

import GroupBookingsForm from 'components/GroupBookingsForm';
import PageWrapper from 'components/PageWrapper';

import { getGroupBookingsForm } from 'utils/graphcms/queries/groupBookingsForm';
import { getLocationPaths } from 'utils/helpers';

export default function GroupBookingFormPage({ page }) {
  return (
    <>
      {/* For the SalesForce web to lead form integration */}
      <Head>
        <meta httpEquiv="Content-type" content="text/html; charset=UTF-8" />
      </Head>

      <PageWrapper page={page} hideFooter>
        <GroupBookingsForm page={page} />
      </PageWrapper>
    </>
  );
}

export async function getStaticProps({ params: { location } }) {
  const page = await getGroupBookingsForm(location);
  return {
    props: { page },
  };
}

export const getStaticPaths = () => getLocationPaths();
